import { Injectable } from "@angular/core";
import { e } from "@angular/core/src/render3";
import { CookieService } from "ngx-cookie-service";
import { DecryptPipe } from "../auth/_services/encrypt-decrypt.pipe";
import { Http, RequestOptions } from "@angular/http";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { environment } from "./../../environments/environment";
import { Headers } from "@angular/http";
import { Helpers } from "../helpers";
declare var jquery: any;
declare var $: any;

@Injectable()
export class CommonService {
  setHeaderAndOptionsForFileUpload(selectedFile: any): { formData: any; options: any; } {
    throw new Error('Method not implemented.');
  }
  onlyAlphabetRegEx = new RegExp(/^[A-Za-z]+$/);
  onlyAlphabetAndSpaceRegEx = new RegExp(/^[A-Za-z ]+$/);
  onlyWithoutSpecialCharRegEx = new RegExp(/^[A-Za-z0-9 ]+$/);
  RegExForGST = new RegExp(
    /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){1}([0-9]){1}?$/
  );

  constructor(
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private ngHttp: Http,
    private httpClient: HttpClient,
    private toastr: ToastrService
  ) { }

  ValidateDate(ctrl, ctrl2, ValidationMessage, ValidationPosition) {
    try {
      var FromDate = new Date(
        ctrl.data("datepicker").getFormattedDate("yyyy/mm/dd")
      );
      var ToDate = new Date(
        ctrl2.data("datepicker").getFormattedDate("yyyy/mm/dd")
      );

      this.ClearMessage(ctrl);
      this.ClearMessage(ctrl2);

      if (FromDate > ToDate) {
        $(ctrl).closest(".form-group").addClass("has-error");
        $(ctrl2).closest(".form-group").addClass("has-error");
        //  $(ctrl).closest('.control-label').addClass('text-danger');
        this.PrintMessage(ctrl, ValidationMessage, ValidationPosition);
        this.PrintMessage(ctrl2, ValidationMessage, ValidationPosition);
        return false;
      }
      return true;
    } catch (e) {
      console.log(e.message, e);
    }
    return true;
  }

  ValidateRequiredField(ctrl, ValidationMessage, ValidationPosition, defValue) {
    try {
      this.ClearMessage(ctrl);
      if (
        $(ctrl).val() === "" ||
        $(ctrl).val() === defValue ||
        $(ctrl).val() === null
      ) {
        $(ctrl).closest(".form-group").addClass("has-error");
        $(ctrl).parent(".form-group").addClass("has-error");
        //  $(ctrl).closest('.control-label').addClass('text-danger');
        this.PrintMessage(ctrl, ValidationMessage, ValidationPosition);
        return false;
      }
      return true;
    } catch (e) {
      console.log(e.message, e);
    }
    return true;
  }

  ValidateRequiredField2(
    ctrl,
    vctrl,
    ValidationMessage,
    ValidationPosition,
    defValue
  ) {
    try {
      this.ClearMessage(vctrl);
      if ($(vctrl).find(".select2-selection__rendered").length) {
        $(vctrl).find(".select2-selection__rendered").css("border", "");
        $(vctrl).find(".select2-selection__rendered").css("box-shadow", "");
      }
      if ($(vctrl).find(".dropdown").length) {
        $(vctrl).find(".dropdown").css("border", "");
        $(vctrl).find(".dropdown").css("box-shadow", "");
      }
      if (
        $(ctrl).val() == "" ||
        $(ctrl).val() == defValue ||
        $(ctrl).val() == null
      ) {
        $(ctrl).closest(".form-group").addClass("has-error");
        $(vctrl).closest(".input-group").addClass("has-error");

        if ($(vctrl).find(".select2-selection__rendered").length) {
          $(vctrl)
            .find(".select2-selection__rendered")
            .css("border", "1px solid #dd4b39");
          $(vctrl)
            .find(".select2-selection__rendered")
            .css("box-shadow", "inset 0 1px 1px rgba(0, 0, 0, 0.075)");
        }
        if ($(vctrl).find(".dropdown").length) {
          $(vctrl).find(".dropdown").css("border", "1px solid #dd4b39");
          $(vctrl)
            .find(".dropdown")
            .css("box-shadow", "inset 0 1px 1px rgba(0, 0, 0, 0.075)");
        }

        this.PrintMessage(vctrl, ValidationMessage, ValidationPosition);
        return false;
      }
      return true;
    } catch (e) { }
  }

  CheckEmail(ctrl, ValidationPosition) {
    this.ClearMessage(ctrl);
    if ($(ctrl).val() !== "") {
      //var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      var regex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regex.test(ctrl.val())) {
        $(ctrl).closest(".form-group").addClass("has-error");
        this.PrintMessage(ctrl, "Invalid Email Address", ValidationPosition);
        return false;
      }
    }
    return true;
  }

  CheckRadioChecked(ctrl1, ctrl2, Message, ValidationPosition) {
    if (
      $(ctrl1).prop("checked") === false &&
      $(ctrl2).prop("checked") === false
    ) {
      this.ClearMessage(ctrl1);
      this.ClearMessage(ctrl2);
      $(ctrl1).closest(".form-group").addClass("has-error");
      this.PrintMessage($(ctrl2).parents("label"), Message, ValidationPosition);
      return false;
    }
    this.ClearMessage(ctrl1);
    this.ClearMessage(ctrl2);
    return true;
  }

  CheckPhoneNumber(ctrl, ValidationPosition) {
    this.ClearMessage(ctrl);
    if ($(ctrl).val() !== "") {
      var regex =
        /(?:\s+|)((0|(?:(\+|)91))(?:\s|-)*(?:(?:\d(?:\s|-)*\d{9})|(?:\d{2}(?:\s|-)*\d{8})|(?:\d{3}(?:\s|-)*\d{7}))|\d{10})/;
      if (!regex.test($(ctrl).val())) {
        $(ctrl).closest(".form-group").addClass("has-error");
        this.PrintMessage(ctrl, "Invalid Phone Number", ValidationPosition);
        return false;
      }
    }
    return true;
  }

  CheckNumber(ctrl, ValidationPosition) {
    this.ClearMessage(ctrl);
    if ($(ctrl).val() !== "") {
      var regex = /^[-+]?[0-9]+$/;
      if (!regex.test($(ctrl).val())) {
        $(ctrl).closest(".form-group").addClass("has-error");
        this.PrintMessage(ctrl, "Not a Number", ValidationPosition);
        return false;
      }
    }
    return true;
  }

  CheckNegativeNumber(ctrl, ValidationPosition) {
    this.ClearMessage(ctrl);
    if ($(ctrl).val() !== "") {
      var regex = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/;
      if (!regex.test($(ctrl).val())) {
        $(ctrl).closest(".form-group").addClass("has-error");
        this.PrintMessage(
          ctrl,
          "Negative number is not allowed ! ",
          ValidationPosition
        );
        return false;
      }
    }
    return true;
  }

  ClearMessage(ctrl) {
    if ($(ctrl).find(".select2-selection__rendered").length) {
      $(ctrl).find(".select2-selection__rendered").css("border", "");
      $(ctrl).find(".select2-selection__rendered").css("box-shadow", "");
    }
    if ($(ctrl).find(".dropdown").length) {
      $(ctrl).find(".dropdown").css("border", "");
      $(ctrl).find(".dropdown").css("box-shadow", "");
    }
    $(ctrl).parent().removeClass("has-error");
    $(ctrl).closest(".form-group").removeClass("has-error");
    $(ctrl).closest(".input-group").removeClass("has-error");

    $(ctrl).closest(".help-block").remove();
    $(ctrl).next(".help-block").remove();
    $(ctrl).prev(".help-block").remove();
  }

  PrintMessage(ctrl, Message, ValidationPosition) {
    if (ctrl.parent().hasClass("input-group")) {
      if (ValidationPosition === "after") {
        $(
          '<span class="help-block help-block-error">' + Message + "</span>"
        ).insertAfter($(ctrl).parent());
      } else {
        $(
          '<span class="help-block help-block-error">' + Message + "</span>"
        ).insertBefore($(ctrl).parent());
      }
    } else if (ValidationPosition === "after") {
      $(
        '<span class="help-block help-block-error">' + Message + "</span>"
      ).insertAfter($(ctrl));
    } else {
      $(
        '<span class="help-block help-block-error">' + Message + "</span>"
      ).insertBefore($(ctrl));
    }
  }

  PrintRadioMessage(ctrl, Message, ValidationPosition) {
    if (ctrl.closest("div").hasClass("m-radio-list")) {
      if (ValidationPosition === "after") {
        $(
          '<span class="help-block help-block-error">' + Message + "</span>"
        ).insertAfter($(ctrl.closest("div")));
      } else {
        $(
          '<span class="help-block help-block-error">' + Message + "</span>"
        ).insertBefore($(ctrl.closest("div")));
      }
    }
  }

  RoleRightsData: any = [];
  public CheckHasRight(RightCode, ScreenCode): Boolean {
    this.RoleRightsData = JSON.parse(localStorage.getItem("rights_assigned"));
    var flag: Boolean = true;
    let UserRole = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("SetUserRole"))
    );
    if (UserRole.match("Admin")) {
      return true;
    }
    this.RoleRightsData.forEach((element) => {
      if (element.ScreenCode == ScreenCode && element.RightCode == RightCode) {
        if (element.RoleScreenRightsId == null) {
          flag = false;
        }
      }
    });
    return flag;
  }

  public CheckHasRightbackdatedentry(RightCode, ScreenCode): Boolean {

    this.RoleRightsData = JSON.parse(localStorage.getItem("rights_assigned"));
    var flag: Boolean = true;
    let UserRole = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("SetUserRole"))
    );

    this.RoleRightsData.forEach((element) => {
      if (element.ScreenCode == ScreenCode && element.RightCode == RightCode) {
        if (element.RoleScreenRightsId == null) {
          flag = false;
        }
      }
    });
    return flag;
  }


  b64toBlob(b64Data, contentType) {
    contentType = contentType || "";
    let sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public GetUserTypeIdsFromLocalStorage() {
    if (JSON.parse(localStorage.getItem("user_Type_Rights")) === null)
      return "";
    return JSON.parse(localStorage.getItem("user_Type_Rights"))
      .map((data) => data.UserTypeId)
      .filter((value, index, self) => self.indexOf(value) == index);
  }

  public GetNetworkTypeIdsFromLocalStorage() {
    if (JSON.parse(localStorage.getItem("user_Type_Rights")) === null)
      return "";
    return JSON.parse(localStorage.getItem("user_Type_Rights"))
      .map((data) => data.NetworkTypeId)
      .filter((value, index, self) => self.indexOf(value) == index);
  }

  public testOnlyAlphabet = (str: string | null): boolean => {
    return this.onlyAlphabetRegEx.test(str);
  };

  public testOnlyAlphabetAndSpace = (str: string | null): boolean => {
    return this.onlyAlphabetAndSpaceRegEx.test(str);
  };
  public testOnlyAlphabetAndNumber = (str: string | null): boolean => {
    return this.onlyWithoutSpecialCharRegEx.test(str);
  };

  public testGSTNumber = (str: string | null): boolean => {
    return this.RegExForGST.test(str);
  };

  public isNullOrUndefined = (obj: any): boolean => {
    return obj === undefined || obj === null;
  };

  public isStringEmptyOrNull = (str: string): boolean => {
    return this.isNullOrUndefined(str) || str.trim() === "";
  };

  public isNotNumberOrNull = (number: string | number): boolean => {
    return this.isNullOrUndefined(number) || isNaN(number as number);
  };

  public isArrayEmpty = (arr: Array<any> | any): boolean => {
    return (
      this.isNullOrUndefined(arr) || !Array.isArray(arr) || arr.length === 0
    );
  };

  updateOrInsertCompanyRegistrations = (data: any): Observable<any> => {
    const requestModel = [
      {
        rfcNumber: data.Number,
        userid: data.UserId,
        DocumentId: data.DocumentId,
      },
    ];
    return this.httpClient.post(
      environment.apiUrl + "api/Signup/UpdateOrInsertCompanyRegistrations",
      requestModel
    );
  };

  uploadDocument = (fileToUpload: File, data: any): void => {

    Helpers.setLoading(true);
    const parentId = null;
    const docSavedSuccess = this.translate.instant("SIGNUP.docSavedSuccess");
    const docSavedFalied = this.translate.instant("SIGNUP.docSavedFalied");
    const formData: FormData = new FormData();
    formData.append("Image", fileToUpload, fileToUpload.name);

    var headers = new Headers();
    let user_access_token = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("user_access_token"))
    );
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });
    const apiUrl =
      environment.apiUrl +
      "/api/Document/UploadAttachment_Custom?ReferenceId=" +
      data.UserId +
      "&TransectionType=" +
      data.DocumentType +
      "&ParentId=" +
      parentId;
    const req1 = this.ngHttp.post(apiUrl, formData, options).subscribe(
      (res) => {
        Helpers.setLoading(false);
        this.toastr.success(
          data.DocumentType + " " + docSavedSuccess,
          "success"
        );
        if (data) {
          this.updateOrInsertCompanyRegistrations(data).subscribe();
        }
      },
      (err) => {
        this.toastr.error(docSavedFalied + DocumentType, "Error");
      }
    );
  };

  onChangeDocumentUpload = (event: any, data: any): void => {

    const reader = new FileReader();

    data.File = event.target.files[0];

    //--------------File True Type Validation ---------- added by vithujan 22-09-2022
    const fileReader = new FileReader();
    let isValidFileType = true;
    fileReader.onloadend = function (e: any) {
      const arr = new Uint8Array(e.target.result).subarray(0, 4);
      let header = "";

      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
      if (
        header.toUpperCase() != "89504E47" &&
        header.toUpperCase() != "FFD8FFE0" &&
        header.toUpperCase() != "FFD8FFE1" &&
        header.toUpperCase() != "25504446"
      ) {
        // this.toastr.error(this.translate.instant("SETTING.ImageOnly"), 'Error');
        $("#" + data.Name + "InputFile").val("");
        isValidFileType = false;
        return false;
      }
    };
    fileReader.readAsArrayBuffer(data.File);
    //----------------------------------------------

    setTimeout(() => {
      if (isValidFileType == true) {
        //--------------Filename Validation ---------- added by vithujan 23-09-2022
        const format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
        if (!format.test(data.File.name)) {
          this.toastr.error(
            this.translate.instant("SETTING.InvalidFile"),
            "Error"
          );
          $("#" + data.Name + "InputFile").val("");
          return false;
        }
        //--------------File Type Validation ---------- added by vithujan 16-09-2022
        const meme_type = data.File.type;
        if (
          meme_type.toLowerCase() != "image/jpeg" &&
          meme_type.toLowerCase() != "image/png" &&
          meme_type.toLowerCase() !== "application/pdf"
        ) {
          this.toastr.error(
            this.translate.instant("SETTING.ImageOnly"),
            "Error"
          );
          $("#" + data.Name + "InputFile").val("");
          return false;
        }

        //--------------Size Validation----------------
        const bytesize = data.File.size;
        let kbsize: any = 0;
        kbsize = (bytesize / 1000).toFixed(2);
        let IsFileSizeExceed = false;
        if (kbsize > 1024) {
          if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
          else IsFileSizeExceed = false;
        }
        if (IsFileSizeExceed) {
          this.toastr.error(
            this.translate.instant("SETTING.FileSize"),
            "Error"
          );
          $("#" + data.Name + "InputFile").val("");
          return false;
        }
        //----------------------------------------------

        reader.onload = (e: any) => {
          data.previewImage = e.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);

        data.FileName = data.File.name;

        this.uploadDocument(data.File, data);
      }
    }, 2000);
  };
}
